import store from '@/store'

export async function requireAuth(to, from, next, reload) {
	if (!store.getters.loggedIn) {
		if (reload) {
			return next('/login')
		}
	} else {
		if (!reload) {
			return next('/dashboard')
		}
	}

	next()
}
